import { Component, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { FikoYTKokBilesenComponent } from '@service/kok-bilesen/kok-bilesen.component';

@Component({
  selector: 'hmi-projeler-pano',
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './pano.component.html',
  styleUrl: './pano.component.less',
})
export class HmiProjelerPanoComponent extends FikoYTKokBilesenComponent {
  constructor() {
    super();
  }
}
